"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@unform/core");
var _ = __importStar(require("lodash"));
var Radio_style_1 = __importDefault(require("./Radio.style"));
exports.Radio = function (_a) {
    var _b;
    var children = _a.children, name = _a.name, value = _a.value, options = _a.options, title = _a.title, color = _a.color, dataCy = _a["data-cy"], rest = __rest(_a, ["children", "name", "value", "options", "title", "color", 'data-cy']);
    var inputRefs = react_1.useRef([]);
    var _c = core_1.useField(name), fieldName = _c.fieldName, registerField = _c.registerField, defaultValue = _c.defaultValue, error = _c.error, clearError = _c.clearError;
    react_1.useEffect(function () {
        registerField({
            name: fieldName,
            ref: inputRefs.current,
            path: 'value',
            setValue: function (refs, _value) {
                var item = options.findIndex(function (option) {
                    return _.isEqual(option.id, _value);
                });
                if (item !== -1) {
                    refs[item].checked = true;
                }
            },
            getValue: function (refs) {
                var checked = refs.find(function (ref) { return ref === null || ref === void 0 ? void 0 : ref.checked; });
                return checked ? checked.value : null;
            },
            clearValue: function (ref) {
                ref.checked = false;
            },
        });
    }, [fieldName, registerField, options]);
    return (react_1.default.createElement(Radio_style_1.default, { color: color },
        options.map(function (option, index) { return (react_1.default.createElement("div", { className: "checkbox-container", key: name + "-radio-" + index },
            react_1.default.createElement("label", { className: "checkbox-container clean", "data-cy": dataCy },
                react_1.default.createElement("input", __assign({ type: "radio", name: name, value: option.id, disabled: option.disabled, ref: function (elRef) {
                        inputRefs.current[index] = elRef;
                    }, defaultChecked: _.isEqual(defaultValue, option.id) }, rest, { onChange: function () {
                        if (error) {
                            clearError();
                        }
                        if (rest === null || rest === void 0 ? void 0 : rest.onChange) {
                            rest.onChange();
                        }
                    } })),
                react_1.default.createElement("span", { className: "checkbox " + (error && 'has-error') + " " + (option.disabled && 'disabled'), "data-testid": "input-radio-circle" }),
                react_1.default.createElement("span", { className: "title " + (option.disabled && 'disabled') }, option.label)))); }),
        error && (react_1.default.createElement("div", { "data-cy": "input-error." + ((_b = rest['data-cy']) !== null && _b !== void 0 ? _b : ''), className: "error-input", "data-testid": "input-error" }, error))));
};
//# sourceMappingURL=Radio.js.map